import AccAccountType from '@/models/Accounting/AccAccountType'
//
export default [
    {
        name: 'acc_account_type_id',
        props: {
            hideDetails: true,
            label: 'Glosa',
            model: AccAccountType,
            itemText: 'comment',
            itemValue: 'id',
            paramSearch: 'comment',
            noObject: true,
        },
        type: 'autocomplete-model',
        value: '',
    },
    {
        name: 'code_exact',
        props: {
            hideDetails: true,
            label: 'Código exacto',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'code',
        props: {
            hideDetails: true,
            label: 'Código',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'comment',
        props: {
            hideDetails: true,
            label: 'Comentario',
        },
        type: 'text-field',
        value: '',
    },
    // {
    //     field: 'acc_account_type_id',
    //     options: [],
    //     props: {
    //         itemText: 'comment',
    //         itemValue: 'id',
    //     },
    //     value: '',
    //     label: 'Tipo de cuenta',
    // },
    // {
    //     field: 'code_exact',
    //     value: '',
    //     label: 'Código exacto',
    // },
    // {
    //     field: 'code',
    //     value: '',
    //     label: 'Código',
    // },
    // {
    //     field: 'comment',
    //     value: '',
    //     label: 'Comentario',
    // },
]
